const HOST = 'https://api.paystack.co'
const ENDPOINTS = {
  verifyTransaction: (reference) => `transaction/verify/${reference}`,
  chargeAuthorization: 'transaction/charge_authorization',
  transactionsList: 'transaction',
  dedicatedAccounts: 'dedicated_account',
  customer: 'customer'
}

class PaystackBase {
  constructor (
    paystackSecret,
    isomorphicFetch,
    logger
  ) {
    this.SECRET_KEY = paystackSecret
    this.fetch = isomorphicFetch
    this.logger = logger
  }

  async request (method, path, body) {
    const endpoint = `${HOST}/${path}`
    const options = {
      method: method.toUpperCase(),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.SECRET_KEY}`
      }
    }
    if (body) {
      Object.assign(options, {
        body: JSON.stringify(body)
      })
    }
    const response = await this.fetch(endpoint, options)
    return response.json()
  }

  verifyTransaction (reference) {
    return this.request('GET', ENDPOINTS.verifyTransaction(reference))
  }

  chargeAuthorization (data) {
    return this.request('POST', ENDPOINTS.chargeAuthorization, data)
  }

  transactionsList (data = {}) {
    const query = new URLSearchParams(data)
    return this.request('GET', `${ENDPOINTS.transactionsList}?=${query.toString()}`)
  }

  createDedicatedVirtualAccount ({ customerId, preferredBank, firstName, lastName, phoneNumber }) {
    const requestBody = {
      customer: customerId,
      preferred_bank: preferredBank || 'titan-paystack',
      first_name: firstName,
      last_name: lastName,
      phone: phoneNumber
    }

    return this.request('POST', ENDPOINTS.dedicatedAccounts, requestBody)
  }

  createPaystackCustomer (data) {
    return this.request('POST', ENDPOINTS.customer, data)
  }

  getDedicatedAccounts (customerId, page) {
    let query = customerId ? `?customer=${customerId}` : ''
    if (page) {
      query = customerId ? `&page=${page}` : `?page=${page}`
    }
    return this.request('GET', `${ENDPOINTS.dedicatedAccounts}${query}`)
  }

  getPaystackCustomer (customerEmail) {
    return this.request('GET', `${ENDPOINTS.customer}/${customerEmail}`)
  }

  listCustomers (page) {
    return this.request('GET', `${ENDPOINTS.customer}${page ? `?page=${page}` : ''}`)
  }

  getBanks () {
    return this.request('GET', `${ENDPOINTS.dedicatedAccounts}/available_providers`)
  }
}

module.exports = PaystackBase
